export const implementedEvents = [
  'annotation_imported',
  'annotation_import_succeeded',
  'annotation_import_failed',
  'annotation_confirmed',
  'annotation_exported',
  'annotation_export_succeeded',
  'annotation_export_failed',
  'validation',
] as const;

export const getDefaultEvent = <T>(actionDef: {
  supportedEvents: readonly [T, ...T[]];
}) => actionDef.supportedEvents[0];

export const canChangeEvent = <T>(actionDef: {
  supportedEvents: ReadonlyArray<T>;
}) => actionDef.supportedEvents.length > 1;
